import { getList } from '@/api/defaultApi'
import setTableHeaderFuel from '@/utils/store/logistic/setTableHeaderFuel'
import setTableDataValuesFuel from '@/utils/store/logistic/setTableDataValuesFuel'
import setTableDataValuesCustomerWork from '@/utils/store/logistic/setTableDataValuesCustomerWork'
import setArrOfObjects from '@/utils/store/logistic/setArrOfObjects'
import { prepareFormDataJoin } from '@/utils/form/prepareFormDataJoin'
import { createIdRandom } from '@/utils/create'

const initialState = () => {
  return {
    urlReport: 'logistics-report/html/',
    urlExcel: 'logistics-report/excel/',

    reportTypes: [
      { name: 'Основной табличный отчет', value: 'main_table' },
      { name: 'Отчет по топливу', value: 'fuel' },
      { name: 'Реестр по внутренним участкам', value: 'internal_register' },
      { name: 'Реестр по заказчикам', value: 'register_of_customers' },
      { name: 'Табель учета рабочего времени', value: 'time_sheet' },
      { name: 'Отчет о работе автотранспорта', value: 'work_of_vehicles' },
      { name: 'Реестр по транспорту', value: 'vehicle_register' }
    ],
    reportActive: '',

    filter: {
      period: '',
      transport: [],
      object: [],
      customer: []
    },

    errorMessage: '',

    isLoading: false,

    // отчет
    reportData: [],
    reportTransport: {},
    reportCustomers: [],

    // табы
    tabs: [],
    tabActive: 0,

    tabsSub: {},
    tabSubActive: 0
  }
}

const state = initialState

const getters = {
  getUrlReport: state => state.urlReport + state.reportActive,
  getUrlExcel: state => state.urlExcel + state.reportActive,

  // табы
  visibleTabs: state => state.tabs.length,
  getTabs: state => {
    return state.tabs.map(item => ({ name: item }))
  },

  visibleTabsSub: state => state.tabsSub.length || Object.keys(state.tabsSub).length,
  getTabsSub: state => {
    return state.tabsSub[state.tabs[state.tabActive]].map(item => ({ name: item }))
  },

  // шапка таблицы
  getTableHeaders: (state, getters) => {
    if (!getters.hasReportData) return []

    switch (state.reportActive) {
      case 'main_table': {
        return [
          { title: 'Дата путевого листа' },
          ...setTableHeaderFuel(state.reportData[state.tabs[state.tabActive]].fuel_codes),
          { title: 'Пройдено' },
          { title: 'Начальный пробег' },
          { title: 'Конечный пробег' },
          { title: 'Водитель' },
          { title: 'Дата выезда' },
          { title: 'Дата заезда' },

          // имена ответственных в шапке
          ...state.reportCustomers.map(item => ({ title: item }))
        ]
      }
      case 'fuel': {
        return [
          { title: 'Автотранспорт' },
          { title: 'Марка топлива' },
          { title: 'Остаток на начало месяца' },
          { title: 'Получено всего за месяц' },
          { title: 'Пробег за месяц' },
          { title: 'Норма расхода топлива летом' },
          { title: 'Норма расхода топлива зимой' },
          { title: 'Расход топлива за месяц по норме' },
          { title: 'Расход топлива за месяц по ГЛОНАСС' },
          { title: 'Пробег за месяц по ГЛОНАСС' },
          { title: 'Фактический остаток топлива на конец месяца' },
          { title: 'Остаток топлива на конец месяца по п/л' }
        ]
      }
      case 'internal_register': return [
        { title: '#' },
        { title: 'Ответственный' },

        //  Список ТС
        ...Object.keys(state.reportTransport).map(item => ({ title: item, mod: 'innerHTML' })),

        { title: 'Отработано часов' }
      ]
      case 'register_of_customers': return [
        { title: '#' },
        { title: 'Дата аренды спецтехники' },
        { title: 'Количество отработанного времени' },
        { title: 'Стоимость отработанного времени, с НДС' },
        { title: 'Примечание' }
      ]
      case 'time_sheet': return [
        [
          { title: '#', isRowspan: true, rowspan: 2 },
          { title: 'ФИО', isRowspan: true, rowspan: 2 },
          { title: 'Должность', isRowspan: true, rowspan: 2 },
          { title: 'Табельный номер', isRowspan: true, rowspan: 2 },
          { title: 'Отметки о количестве отработанных часов и количестве неявок', isColspan: true, colspan: state.reportData.countDays },
          { title: 'Итого отработано', isColspan: true, colspan: 3 },
          { title: 'Количество неявок на работу, дней', isColspan: true, colspan: 5 },
          { title: 'Тарифная ставка (часовая, дневная)', isRowspan: true, rowspan: 2 },
          { title: 'Тарифная ставка (ремонт)', isRowspan: true, rowspan: 2 },
          { title: 'Фонд оплаты труда, руб.', isRowspan: true, rowspan: 2 }
        ],
        [
          // Отметки о количестве отработанных часов и количестве неявок
          ...Array.from({ length: state.reportData.countDays },
            (_, i) => (
              { title: i + 1 }
            )),
          // итого
          { title: 'Дней' },
          { title: 'Часов' },
          { title: 'В т.ч. в командировке' },
          // кол-во неявок
          { title: 'Выходные и праздничные дни' },
          { title: 'Отпуск' },
          { title: 'По болезни' },
          { title: 'Прогулы' },
          { title: 'Прочее' }
        ]
      ]
      case 'work_of_vehicles': {
        const reportTransport = [...Object.values(state.reportData.transport)]
        return [
          [
            { title: '#', isRowspan: true, rowspan: 2 },
            { title: 'Участок (заказчик)', isRowspan: true, rowspan: 2 },
            { title: 'Марка и номер автомобиля', isColspan: true, colspan: reportTransport.length },
            { title: 'Всего отработано, час', isRowspan: true, rowspan: 2 },
            { title: 'Всего предъявлено к оплате, руб', isRowspan: true, rowspan: 2 }
          ],
          [
            ...reportTransport
              .map(transport => (
                { title: transport.name }
              ))
          ]
        ]
      }
      case 'vehicle_register': return [
        // mounth ??
        { title: 'ФИО' },
        // числа
        ...Array.from({ length: Object.values(state.reportData.numberDaysInMonth)[state.tabActive]?.number },
          (_, i) => ({ title: i + 1 })),
        { title: 'Итого, час' },
        { title: 'Итого, руб' }
      ]
      default: return []
    }
  },

  // данные для таблицы
  hasReportData: state => state.reportData.length || Object.keys(state.reportData).length,
  getTableData: (state, getters) => {
    if (!getters.hasReportData) return []

    switch (state.reportActive) {
      case 'main_table': {
        const report = { ...state.reportData[state.tabs[state.tabActive]] }

        if ('fuel_codes' in report) {
          delete report.fuel_codes
        }

        return Object.values(report).map(item => {
          return {
            id: item.id,
            values: [
              { data: item.date_at, mod: 'date-simple' },

              // топливо
              ...setTableDataValuesFuel(item.fuel_balance),

              { data: item.distance_set, mod: '' },
              { data: item.distance_start, mod: '' },
              { data: item.distance_end, mod: '' },
              { data: item.driver.full_name, mod: '' },
              { data: item.start_at, mod: 'date' },
              { data: item.end_at, mod: 'date' },

              // количество отработанных часов по ответственным
              ...setTableDataValuesCustomerWork(state.reportCustomers, item.work)
            ]
          }
        })
      }
      case 'fuel': {
        const report = { ...state.reportData[state.tabs[state.tabActive]] }

        const tableData = []

        for (const car in report) {
          const data = report[car]
          const fuelData = Object.values(data.fuel)

          const item = {
            ...createIdRandom(),
            values: [
              { data: car, mod: 'innerHTML' },
              { data: Object.keys(data.fuel), mod: 'many' },
              { data: setArrOfObjects(fuelData, 'balance_at'), mod: 'many' },
              { data: setArrOfObjects(fuelData, 'balance_add'), mod: 'many' },
              { data: data.distance_total, mod: '' },

              // расход средний летом и зимой
              { data: setArrOfObjects(fuelData, 'consumption_rate_summer'), mod: 'many' },
              { data: setArrOfObjects(fuelData, 'consumption_rate_winter'), mod: 'many' },

              // TODO: Дописать расход топлива по норме за месяц
              { data: '', mod: '' },

              { data: setArrOfObjects(fuelData, 'balance_consumption'), mod: 'many' },
              { data: data.distance_total, mod: '' },
              { data: setArrOfObjects(fuelData, 'balance_to'), mod: 'many' },
              { data: setArrOfObjects(fuelData, 'balance_to'), mod: 'many' }
            ]
          }

          tableData.push(item)
        }

        return tableData
      }
      case 'internal_register': {
        const report = { ...state.reportData[state.tabs[state.tabActive]] }
        const tableData = []
        const reportTransport = Object.keys(state.reportTransport)

        let totalTime = 0

        for (const responsible in report) {
          const data = report[responsible]

          const workingTime = []

          reportTransport.forEach(car => {
            let hours = 0

            if (data[car] && data[car].length) {
              data[car].forEach(work => {
                hours += Number(work.amount_of_time)
              })
            }

            workingTime.push({ data: hours, mod: '' })
          })

          const totalTimeResponsible = workingTime.reduce((prevValue, currentValue) => prevValue + currentValue.data, 0)
          totalTime += totalTimeResponsible

          const item = [
            { data: responsible, mod: '' },

            // время по ТС
            ...workingTime,

            { data: totalTimeResponsible, mod: '' }
          ]

          tableData.push(item)
        }

        const totalAll = [{ data: 'Итого:', mod: '' }]

        reportTransport.forEach(car => {
          totalAll.push({
            data: state.reportTransport[car][state.tabs[state.tabActive]],
            mod: ''
          })
        })

        totalAll.push({ data: totalTime, mod: '' })

        tableData.push(totalAll)

        return tableData.map((item, i) => ({
          id: i,
          values: item
        }))
      }
      case 'register_of_customers': {
        const mounth = state.tabs[state.tabActive]
        const customer = state.tabsSub[state.tabs[state.tabActive]][state.tabSubActive]

        const report = { ...state.reportData[mounth][customer] }

        const tableData = []

        for (const car in report) {
          if (report[car].length) {
            tableData.push([{ data: car.replace('<br/>', ' '), mod: '' }])

            report[car].forEach(car => {
              const item = [
                { data: car.waybill.start_at.slice(0, 10), mod: 'date' },
                { data: car.amount_of_time, mod: '' },
                { data: '', mod: '' },
                { data: car.description, mod: '' }
              ]

              tableData.push(item)
            })
          }
        }

        const totalTime = tableData.reduce((prevValue, currentValue) => {
          if (currentValue[1]) {
            prevValue += Number(currentValue[1].data)
          }

          return prevValue
        }, 0)

        tableData.push([
          { data: 'Итого:', mod: '' },
          { data: totalTime, mod: '' }
        ])

        return tableData.map((item, i) => ({
          id: i,
          values: item
        }))
      }
      case 'time_sheet': {
        const report = [...state.reportData.reportData]
        const tableData = []

        report.forEach(driver => {
          const transports = Object.keys(driver.transports)
          const daysWorking = []
          for (let i = 1; i <= state.reportData.countDays; i++) {
            const allTime = []

            transports.forEach(id => {
              let time = '-'

              if (driver.days[i][id] && Object.values(driver.days[i][id]).length) {
                time = Object.values(driver.days[i][id]).join('; ')
              }

              allTime.push(time)
            })

            daysWorking.push({ data: allTime, mod: 'many' })
          }

          const item = [
            { data: driver.full_name, mod: '' },
            { data: Object.values(driver.transports), mod: 'many' },
            // табельный
            { data: driver.personal_number, mod: '' },
            // кол-во часов по числам
            ...daysWorking,
            // дней
            { data: Object.values(driver.total_days), mod: 'many' },
            // часов за месяц
            { data: Object.values(driver.total_hours), mod: 'many' },
            // в т.ч. в командировке
            { data: Object.values(driver.total_missions), mod: 'many' },
            // неявки на работу
            { data: [], mod: 'many' },
            { data: [], mod: 'many' },
            { data: [], mod: 'many' },
            { data: [], mod: 'many' },
            { data: [], mod: 'many' },

            // ставка
            { data: Object.values(driver.tariff_rate), mod: 'many' },
            { data: Object.values(driver.tariff_repair), mod: 'many' },
            // оклад
            { data: driver.salary, mod: '' }
          ]

          tableData.push(item)
        })

        tableData.push([
          { data: 'Итого:', mod: '', isColspan: true, colspan: 3 + state.reportData.countDays },
          { data: state.reportData.totalDays, mod: '' },
          { data: state.reportData.totalHours, mod: '' },
          { data: state.reportData.totalMissions, mod: '' },
          { data: ' ', mod: '', isColspan: true, colspan: 7 },
          { data: state.reportData.totalPay, mod: '' }
        ])

        return tableData.map((item, i) => {
          return {
            id: i,
            values: item
          }
        })
      }
      case 'work_of_vehicles': {
        const report = { ...state.reportData }
        const tableData = []
        const transportIdList = Object.keys(report.transport)

        report.objects.forEach(object => {
          const transportOfObject = object.transport
          const transportData = []

          transportIdList.forEach(id => {
            let time = '-'

            if (id in transportOfObject) {
              time = transportOfObject[id]
            }

            transportData.push({ data: time, mod: '' })
          })

          const item = [
            { data: object.name, mod: '' },
            ...transportData,
            { data: object.totalHours, mod: '' },
            { data: object.toPay, mod: '' }
          ]
          tableData.push(item)
        })

        tableData.push([
          { data: 'Итого:', mod: '', isColspan: true },
          ...Object.values(report.transport)
            .map(transport => (
              { data: transport.totalHours, mod: '' }
            )),
          { data: report.totalHours, mod: '' },
          { data: report.toPay, mod: '' }
        ])

        return tableData.map((item, i) => {
          return {
            id: i,
            values: item
          }
        })
      }
      case 'vehicle_register': {
        const report = { ...state.reportData }
        const tableData = []

        const countDays = Object.values(report.numberDaysInMonth)[state.tabActive]?.number
        if (!countDays) return []

        const totalHoursDrivers = Object.values(report.totalHoursDrivers)[state.tabActive]
        const driverHours = Object.values(report.driverHours)[state.tabActive]
        const totalPayOnDrivers = Object.values(report.totalPayOnDrivers)[state.tabActive]

        for (const driver in totalHoursDrivers) {
          const timeDays = []

          for (let i = 1; i <= countDays; i++) {
            let time = 0

            if (driverHours[driver][`${i}`]) {
              time = driverHours[driver][`${i}`]
            }

            timeDays.push({ data: time, mod: '' })
          }

          const item = [
            { data: driver, mod: '' },
            ...timeDays,
            { data: totalHoursDrivers[driver], mod: '' },
            { data: totalPayOnDrivers[driver], mod: '' }
          ]

          tableData.push(item)
        }

        const totalData = [{ data: 'Итого:', mod: '' }]

        const totalHoursOnDayDrivers = Object.values(report.totalHoursOnDayDrivers)[state.tabActive]

        for (let i = 1; i <= countDays; i++) {
          let total = 0

          if (totalHoursOnDayDrivers[`${i}`]) {
            total = totalHoursOnDayDrivers[`${i}`]
          }

          totalData.push({ data: total, mod: '' })
        }

        totalData.push(
          { data: Object.values(report.totalHours)[state.tabActive], mod: '' },
          { data: Object.values(report.totalPay)[state.tabActive], mod: '' }
        )

        tableData.push(totalData)

        return tableData.map((item, i) => ({
          id: i,
          values: item
        }))
      }
      default: return []
    }
  }
}

const mutations = {
  SET_REPORT: (state, data) => {
    if (!data) return
    const tabs = Object.keys(data)

    // установка табов
    switch (state.reportActive) {
      case 'register_of_customers': {
        const tabsSub = {}

        tabs.forEach(key => {
          tabsSub[key] = Object.keys(data[key])
        })

        state.tabsSub = tabsSub
        state.tabs = tabs
        break
      }
      case 'time_sheet':
      case 'work_of_vehicles': {
        break
      }
      case 'vehicle_register': {
        state.tabs = Object.values(data.numberDaysInMonth)
          .map(item => item.name)
        break
      }
      default: {
        state.tabs = tabs
      }
    }

    state.reportData = data
  },

  SET_REPORT_TRANSPORT: (state, data) => {
    state.reportTransport = data
  },

  SET_REPORT_CUSTOMERS: (state, customers) => {
    state.reportCustomers = customers
  },

  SET_REPORT_ACTIVE: (state, value) => {
    state.reportActive = value
  },

  SET_FILTER: (state, data) => {
    let filter = { ...data }
    delete filter.report

    const keyById = [
      'object',
      'transport'
    ]
    filter = prepareFormDataJoin(filter, keyById)

    filter = prepareFormDataJoin(filter, ['customer'], 'responsible')

    state.filter = { ...filter }
  },

  SET_REPORT_ERROR_MESSAGE: (state, value) => {
    state.errorMessage = value

    setTimeout(function () {
      state.errorMessage = ''
    }, 5000)
  },

  SET_TAB_ACTIVE: (state, i) => {
    state.tabActive = i
    state.tabSubActive = 0
  },

  SET_TAB_SUB_ACTIVE: (state, i) => {
    state.tabSubActive = i
  },

  SET_IS_LOADING: (state, bool) => {
    state.isLoading = bool
  },

  // очистка
  CLEAR_FILTER: state => {
    state.filter.period = null
    state.filter.customer = []
    state.filter.object = []
    state.filter.transport = []
  },

  CLEAR_REPORT: state => {
    state.reportData = []
    state.reportCustomers = []

    state.tabs = []
    state.tabActive = 0
    state.tabsSub = []
    state.tabSubActive = 0
  },

  RESET_STORE: state => {
    Object.assign(state, initialState())
  }
}

const actions = {
  async loadReport ({ state, commit, getters }, data) {
    commit('CLEAR_REPORT')
    commit('SET_REPORT_ACTIVE', data.report.value)
    commit('SET_FILTER', data)

    try {
      commit('SET_IS_LOADING', true)
      const response = await getList(getters.getUrlReport, state.filter)

      switch (this.state.reportActive) {
        case 'main_table':
          commit('SET_REPORT_CUSTOMERS', response.data.data.customers)
          commit('SET_REPORT', response.data.data.reportData)
          break

        case 'internal_register':
          commit('SET_REPORT_TRANSPORT', response.data.data.transport)
          commit('SET_REPORT', response.data.data.reportData)
          break

        case 'register_of_customers':
          commit('SET_REPORT', response.data.data.data.reportData)
          break

        default:
          commit('SET_REPORT', response.data.data.reportData)
      }
    } catch (error) {
      console.log('ошибка получения отчета', error)
      console.log('ошибка получения отчета', error.response)
      commit('SET_REPORT_ERROR_MESSAGE', error.response.data.data.message)
    } finally {
      commit('SET_IS_LOADING', false)
    }
  },

  async downloadReport ({ state, commit, getters }) {
    try {
      const response = await getList(getters.getUrlExcel, state.filter)

      const link = document.createElement('a')
      link.href = response.data.data
      link.target = '_blank'
      link.click()
      link.remove()
    } catch (error) {
      console.log('ошибка получения отчета', error.response)
      commit('SET_REPORT_ERROR_MESSAGE', error.response.data.data.message)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
